const hamburgers = Array.from(document.querySelectorAll(".hamburger"));
const sidebarBg = document.querySelector(".sidebar-bg");
const sidebar = document.querySelector(".sidebar");
const sidebarClose = document.querySelector(".sidebar-tenant-collapse");
const body = document.body;
const searchBtn = Array.from(document.querySelectorAll(".search-btn"));
const searchForm = document.querySelector(".search-form");
const searchFormClose = document.querySelector(".search-form__close");

function openSidebar() {
  sidebarBg.classList.add("open");
  sidebar.classList.add("open");
  body.classList.add("sidebar-is-open");
  body.style.overflow = "hidden";
}

function closeSidebar() {
  sidebarBg.classList.remove("open");
  sidebar.classList.remove("open");
  body.classList.remove("sidebar-is-open");
  body.style.overflow = null;
}

hamburgers.forEach(function(hamburger) {
  hamburger.addEventListener('click', function() {
    if (sidebar.classList.contains("open")) {
      closeSidebar();
    } else {
      openSidebar();
    }
  });
});

sidebarBg.addEventListener('click', function() {
  closeSidebar();
});

sidebarClose.addEventListener('click', function() {
  closeSidebar();
});

searchFormClose?.addEventListener('click', function(event) {
  searchForm.classList.remove("open");
  event.stopPropagation();
});

searchForm?.addEventListener('click', function(event) {
  event.stopPropagation();
});

body.addEventListener('click', function(event) {
  if (searchBtn.some(function(btn) { return btn.contains(event.target); })) {
    return;
  }
  if (searchForm && searchForm.classList.contains("open")) {
    searchForm.classList.remove("open");
  }
});

searchBtn.forEach(function(element) {
  element.addEventListener('click', function(event) {
    if (!searchForm.classList.contains("open")) {
      searchForm.classList.add("open");
    }
    event.stopPropagation();
  });
});
